var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 1.33398H6.00065C5.63246 1.33398 5.33398 1.63246 5.33398 2.00065V3.33398C5.33398 3.70217 5.63246 4.00065 6.00065 4.00065H10.0007C10.3688 4.00065 10.6673 3.70217 10.6673 3.33398V2.00065C10.6673 1.63246 10.3688 1.33398 10.0007 1.33398Z",
    stroke: "#6B6B6B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 2.66602H11.9993C12.353 2.66602 12.6921 2.80649 12.9422 3.05654C13.1922 3.30659 13.3327 3.64573 13.3327 3.99935V13.3327C13.3327 13.6863 13.1922 14.0254 12.9422 14.2755C12.6921 14.5255 12.353 14.666 11.9993 14.666H3.99935C3.64573 14.666 3.30659 14.5255 3.05654 14.2755C2.80649 14.0254 2.66602 13.6863 2.66602 13.3327V3.99935C2.66602 3.64573 2.80649 3.30659 3.05654 3.05654C3.30659 2.80649 3.64573 2.66602 3.99935 2.66602H5.33268",
    stroke: "#6B6B6B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.33398H10.6667",
    stroke: "#6B6B6B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.666H10.6667",
    stroke: "#6B6B6B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 7.33398H5.34198",
    stroke: "#6B6B6B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 10.666H5.34198",
    stroke: "#6B6B6B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.e87a63b946ed5c35674c5636aab7e472.svg";
export { ForwardRef as ReactComponent };